module.exports = __webpack_public_path__ + "assets/icon_flow.41dc58ba.svg";